<template>
  <div class="porp-box">
    <div class="porp-body">
      <dl v-for="(filter,index) in filterList" :key="filter.code">
        <dt>
          <h4 class="flex-left">{{filter.name}}</h4>
          <a v-if="filter.list.length > 6" class="flex-left" href="JavaScript:;" :class={cur:filter.showMore} @click="filter.showMore=!filter.showMore">
            {{filter.selectInfo.value?filter.selectInfo.value:filter.showMore ? '收起':'展开全部'}}
          </a>
          <!-- <span v-if="filter.selectInfo && filter.selectInfo.value">{{filter.selectInfo.value}}</span> -->
        </dt>
        <dd class="flex-left transition-all" :style="filterStyle(index)">
          <p v-for="item in filter.list" :key="item.key">
            <a href="JavaScript:;" @click.stop="filter.selectInfo=item" :class="{cur:item.key==filter.selectInfo.key}">{{item.value}}</a>
          </p>
        </dd>
      </dl>
    </div>
    <div class="btn-box-btn">
      <div class="btn-porp flex-center">
        <a href="JavaScript:;" class="flex-center" @click.stop="resetSearch()">重置</a>
        <a href="JavaScript:;" class="flex-center blue" @click.stop="openClosePorp(false)">确定</a>
      </div>
    </div>
  </div>
</template>
<script>
import { getConditionOld } from '../../../request/search'
export default {
  data() {
    return {
      filterList: [],
    }
  },
  created() {
    this.getConditionOld()
  },
  methods: {
    getConditionOld() {
      getConditionOld().then((res) => {
        if (res && res.status === 200 && res.data.data) {
          let psToSkuList = res.data.data.psToSkuList || []
          var filterMap = {}
          psToSkuList.forEach((item) => {
            if (filterMap[item.code]) {
              filterMap[item.code].list.push(item)
            } else {
              filterMap[item.code] = {
                name: item.code == 'categoryAll' ? '全部类目' : item.code == 'shopType' ? '店铺类型' : '其他',
                code: item.code,
                list: [item],
                selectInfo: {},
                showMore: false,
              }
              this.filterList.push(filterMap[item.code])
            }
          })
        }
      })
    },
    filterStyle(index) {
      let oStyle = 'height:'
      if (this.filterList && this.filterList.length) {
        if (this.filterList[index].list && this.filterList[index].list.length > 6) {
          oStyle = 'height:'
          oStyle += (this.filterList[index].showMore ? Math.ceil(this.filterList[index].list.length / 3) : 2) * 4.2
          oStyle += 'rem;'
        } else {
          this.filterList[index].showMore = false
        }
      }
      return oStyle
    },
    resetSearch() {
      this.filterList.forEach((item) => {
        item.selectInfo = {}
      })
      this.$emit('change-event', { filterDetail: false }, false)
    },
    openClosePorp() {
      let param = { filterDetail: false }
      this.filterList.forEach((item) => {
        if (item.code == 'categoryAll') {
          param['categoryId1'] = item.selectInfo.key || 0
        } else if (item.code == 'shopType') {
          param['shopType'] = item.selectInfo.key || 'ALL'
        }
        if (item.selectInfo.key) {
          param['filterDetail'] = true
        }
      })
      this.$emit('change-event', param, true)
    },
  },
}
</script>
<style scoped lang="less">
@import url(../style/filter.less);
</style>